import { useQuery } from '@apollo/client'
import { Box, Divider, Stack } from '@mui/material'
import { type GridRowParams } from '@mui/x-data-grid-pro'
import StarterKit from '@tiptap/starter-kit'
import { RichTextReadOnly } from 'mui-tiptap'
import { type FC } from 'react'
import { GetRosterData } from 'recruiter/components/RosterDrawer/AddOrEdit.gql'
import RosterCandidateRecruiterNotes from 'recruiter/pages/Rosters/RosterProfile/CandidateRosterNoteDrawer/RosterCandidateRecruiterNotes'
import { getPxAsRem } from 'shared/utils'
import { type CandidateRostersTableRowModel } from '../CandidateRosters/CandidateRostersTable'
import RosterPanelJobBoard from './RosterPanelJobBoard'
import RosterPanelProcessStatus from './RosterPanelProcessStatus'

const RosterPanelContent: FC<{
    data: GridRowParams<CandidateRostersTableRowModel>
}> = ({ data }) => {
    const rosterId = data.row.rosterCandidate?.roster?.id
    const { data: rosterData } = useQuery(GetRosterData, {
        variables: { rosterId: rosterId ?? '' },
    })

    return (
        <Stack sx={{ m: getPxAsRem(16, 32) }} spacing={2}>
            <Box color="GrayText">
                <RichTextReadOnly
                    extensions={[StarterKit]}
                    content={
                        data.row.rosterCandidate?.roster?.pitchNote?.note ?? '-'
                    }
                />
            </Box>
            <Divider />
            <Stack direction="row" flexWrap="wrap" gap={2}>
                <RosterCandidateRecruiterNotes
                    rosterCandidateId={data.row.rosterCandidate?.id}
                />
                <Box sx={{ flex: '0 1 auto', minWidth: 200 }}>
                    <RosterPanelProcessStatus
                        rosterId={rosterId ?? ''}
                        history={
                            data.row.rosterCandidate
                                ?.candidateProcessStatusHistory
                        }
                        rosterCandidateId={data.row.rosterCandidate?.id}
                        canEdit={
                            rosterData?.roster?.permissions?.canEdit ?? false
                        }
                    />
                </Box>
            </Stack>

            {data.row.rosterCandidate?.mostRecentJobBoardResponse && (
                <RosterPanelJobBoard
                    canEdit={data.row.permissions?.canEdit}
                    jobBoardData={
                        data.row.rosterCandidate?.mostRecentJobBoardResponse
                    }
                />
            )}
        </Stack>
    )
}

export default RosterPanelContent
